import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { allBoards } from 'selectors/wprsnpr'

import 'stylesheets/board_image.scss'

import unknown_board from 'images/unknown_board.png'


class BoardImage extends React.PureComponent {
  static propTypes = {
    machineName: PropTypes.string
  }

  render() {
    const
      { allBoards, machineName } = this.props,
      board = allBoards[machineName],
      imageSrc = board?.imageUrl || unknown_board

    return <img className="board-image" src={ imageSrc } />
  }
}

const mapState = state => ({ allBoards: allBoards(state) })

export default connect(mapState)(BoardImage)
